// src/constants/options.ts

export const ITEMS_GENDER = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
];

export const ITEMS_BLOOD_TYPE = [
    { label: "A", value: "A" },
    { label: "B", value: "B" },
    { label: "AB", value: "AB" },
    { label: "O", value: "O" },
];

export const ITEMS_CLOTHES_SIZE = [
    { label: "S", value: "S" },
    { label: "M", value: "M" },
    { label: "L", value: "L" },
    { label: "XL", value: "XL" },
    { label: "XXL", value: "XXL" },
    { label: "XXXL", value: "XXXL" },
    { label: "XXXXL", value: "XXXXL" },
    { label: "XXXXXL", value: "XXXXXL" },
];

export const ITEMS_INSTITUTION = [
    { label: "Universitas Pendidikan Ganesha", value: "Universitas Pendidikan Ganesha" },
    { label: "Universitas Negeri Surabaya", value: "Universitas Negeri Surabaya" },
    { label: "Universitas Negeri Malang", value: "Universitas Negeri Malang" },
    { label: "Universitas Negeri Yogyakarta", value: "Universitas Negeri Yogyakarta" },
    { label: "Universitas Negeri Semarang", value: "Universitas Negeri Semarang" },
    { label: "Universitas Negeri Jakarta", value: "Universitas Negeri Jakarta" },
    { label: "Universitas Pendidikan Indonesia", value: "Universitas Pendidikan Indonesia" },
    { label: "Universitas Negeri Padang", value: "Universitas Negeri Padang" },
    { label: "Universitas Negeri Medan", value: "Universitas Negeri Medan" },
    { label: "Universitas Negeri Gorontalo", value: "Universitas Negeri Gorontalo" },
    { label: "Universitas Negeri Manado", value: "Universitas Negeri Manado" },
    { label: "Universitas Negeri Makassar", value: "Universitas Negeri Makassar" },
    { label: "Other", value: "other" },
];